import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThermometerReading, TempDataPoint } from '../version.service';

@Component({
  selector: 'app-klima',
  templateUrl: './klima.component.html',
})
export class KlimaComponent {
  @Input() thermometers:       ThermometerReading[]                    = [];
  @Input() thermometerHistory: {[deviceId: string]: TempDataPoint[]}  = {};
  @Input() thermoFlash         = false;
  @Input() liveDotOn           = true;
  @Input() thermoUpdatedAt:    number | null                           = null;
  @Input() nowTick             = Date.now();
  @Input() darkMode            = false;

  constructor(readonly translate: TranslateService) {}

  sensorName(name: string): string {
    const key = `SENSOR_NAMES.${name}`;
    const t = this.translate.instant(key);
    return t === key ? name : t;
  }

  updatedAgo(ts: number | null): string {
    if (ts === null) return '';
    const s = Math.floor((this.nowTick - ts) / 1000);
    if (s < 60)   return `${s}s`;
    if (s < 3600) return `${Math.floor(s / 60)}min`;
    return `${Math.floor(s / 3600)}h`;
  }

  sparklinePoints(deviceId: string): TempDataPoint[] {
    return this.thermometerHistory[deviceId] ?? [];
  }

  humidityColor(hum: number): string {
    if (hum > 70) return 'text-danger';
    if (hum > 60) return 'text-warning';
    if (hum >= 30) return 'text-success';
    return 'text-warning';
  }

  tempColor(tempC: number): string {
    if (tempC >= 28) return 'text-danger';
    if (tempC >= 22) return 'text-warning';
    if (tempC >= 16) return 'text-success';
    return 'text-info';
  }

  sparklineMinMax(deviceId: string): { min: number; max: number } {
    const pts = this.thermometerHistory[deviceId];
    if (!pts?.length) return { min: 0, max: 0 };
    const temps = pts.map(p => p.tempC);
    return { min: Math.min(...temps), max: Math.max(...temps) };
  }
}
